import { Button, Form, Input, message, Modal, Tooltip } from "antd";
import React from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import PersonsList from "../../Common/components/PersonsList";
import { documentAction } from "../state/actions";
import { v4 as uuidv4 } from "uuid";
import { useMediaQuery } from "react-responsive";

const EditAgents = ({ currentUrlId }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 600 });
  let globalLocalData = {};
  try {
    globalLocalData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
  } catch (error) {
    globalLocalData = {};
  }

  const [editAgentState, setEditAgentState] = React.useState({
    currentAgent: {},
    editMode: false,
    isAddingNew: false,
  });

  const handleDataChange = (updatedAgents = {}) => {
    try {
      let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
      localData = { ...localData, ...updatedAgents };
      localStorage.setItem(currentUrlId, JSON.stringify(localData));
      dispatch(documentAction.setpdfImportState(localData));
    } catch (error) {
      message.error("Failed to update agent data. Please try again.");
    }
  };

  const handleDeleteAgent = (agent) => {
    if (!agent || !agent.key) return message.error("Invalid agent data!");

    Modal.confirm({
      title: `Are you sure you want to remove ${agent.fullName || "this Agent"} from the list?`,
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        try {
          let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
          let newData = localData.BuyerAgents?.filter((el) => el.key !== agent.key) || [];
          handleDataChange({ BuyerAgents: newData });
          message.success(`${agent.fullName || "Agent"} removed successfully.`);
        } catch (error) {
          console.error("Error deleting agent:", error);
          message.error("Failed to delete agent. Please try again.");
        }
      },
    });
  };

  const handleEdit = (agent) => {
    if (!agent) return message.error("Invalid agent data!");
    setEditAgentState({
      currentAgent: agent,
      editMode: true,
      isAddingNew: false,
    });

    form.setFieldsValue({
      fullName: agent.fullName || "",
      email: agent.email || "",
    });
  };

  const handleAddNew = () => {
    setEditAgentState({
      currentAgent: {},
      editMode: true,
      isAddingNew: true,
    });

    form.resetFields();
  };

  const onFinish = (values) => {
    try {
      let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
      let newData = localData.BuyerAgents ? [...localData.BuyerAgents] : [];

      if (editAgentState.isAddingNew) {
        const newAgent = {
          ...values,
          firmName: "",
          resureFirmId: "",
          firmLicense: "",
          license: "",
          address: "",
          phoneNumber: "",
          faxNumber: "",
          personId: null,
          key: uuidv4(),
        };
        newData.push(newAgent);
        message.success("New agent added successfully.");
      } else {
        newData = newData.map((agent) => (agent.key === editAgentState.currentAgent.key ? { ...agent, ...values } : agent));
        message.success("Agent details updated successfully.");
      }

      handleDataChange({ BuyerAgents: newData });
      setEditAgentState({ currentAgent: {}, editMode: false, isAddingNew: false });
      form.resetFields();
    } catch (error) {
      // message.error("Failed to save agent data. Please try again.");
    }
  };

  return (
    <div style={{minHeight:"300px",maxHeight:"400px",overflowY:"auto", width: "100%", padding: "0px",overflowX:"hidden" }}>
      {!editAgentState.editMode && (
        <div style={{ position: "absolute", top: isMobile ? "55px" : "12px", right: "55px" }}>
          <Tooltip title="Add New Agent">
            <Button type="primary" onClick={handleAddNew}>
              Add New
            </Button>
          </Tooltip>
        </div>
      )}
      {!editAgentState.editMode && <PersonsList dataSource={globalLocalData.BuyerAgents || []} onDelete={handleDeleteAgent} handleEdit={handleEdit} showDeleteIcon={true} showEditIcon={true} />}

      {editAgentState.editMode && (
        <Form labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} form={form} onFinish={onFinish} autoComplete="off" style={{ marginTop: isMobile ? "60px" : "30px" }}>
          <Form.Item label={<div style={{ fontSize: "16px", fontWeight: "500", color: "#8e959a" }}>Full Name </div>} name="fullName" rules={[{ required: true, message: "Please Enter Full Name!" }]}>
            <Input placeholder="Enter Full Name" allowClear autoFocus />
          </Form.Item>

          <Form.Item
            label={<div style={{ fontSize: "16px", fontWeight: "500", color: "#8e959a" }}> Email </div>}
            name="email"
            hasFeedback
            rules={[
              {
                type: "email",
                message: "Not a valid Email!",
              },
              {
                required: true,
                message: "Please Enter Email!",
              },
              { whitespace: true },
            ]}
          >
            <Input placeholder="Enter Email" allowClear />
          </Form.Item>

          <Form.Item>
            <div style={{ display: "flex", justifyContent: isMobile ? "center" : "right", marginTop: "20px" }}>
              <Button type="primary" htmlType="submit">
                {editAgentState.isAddingNew ? "Add Agent" : "Done"}
              </Button>
              <Button onClick={() => setEditAgentState({ currentAgent: {}, editMode: false, isAddingNew: false })} style={{ marginLeft: "15px" }}>
                Cancel
              </Button>
            </div>
          </Form.Item>
        </Form>
      )}
    </div>
  );
};

export default EditAgents;
